export default "__VITE_ASSET__BtkFR1MA__"